import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, Send, MessageCircle } from 'lucide-react';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';
import './ContactModal.css';

const TELEGRAM_URL = 'https://t.me/msk_garage';
const MAX_URL = 'https://max.ru/u/f9LHodD0cOJmTd8TnYx3R5e8lzf8_YuddSK0Yh2wCtFrE67E6asIVHOfkPU';

const ContactModal = ({ isOpen, onClose }) => {
  useBodyScrollLock(isOpen);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="contact-modal-overlay" onClick={onClose}>
      <div
        className="contact-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Связаться с нами"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="contact-modal__close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <X size={22} strokeWidth={2} />
        </button>

        <h3 className="contact-modal__title">Связаться с нами</h3>
        <p className="contact-modal__subtitle">Выберите мессенджер для связи</p>

        <div className="contact-modal__actions">
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-modal__option contact-modal__option--telegram"
            onClick={onClose}
          >
            <Send size={22} />
            <span>Telegram</span>
          </a>

          <a
            href={MAX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-modal__option contact-modal__option--max"
            onClick={onClose}
          >
            <MessageCircle size={22} />
            <span>MAX</span>
          </a>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ContactModal;
